/*========================================================================
* $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2014
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/


define(
  "component!resetfilters",
  [
    "client/template",
    "i18n/i18n",
    "component!base",
    "jquery",
    "underscore",
    "utils/clone",
    "utils/navigation-query-params"
  ], function (
    Template,
    i18n,
    Base,
    $,
    _,
    deepClone,
    Navigation
  ) {
  var ResetFilter = Template.extend({

    schema: new Template.Schema({
      attributes: {
        "clear-query-on-reset": {
          type: "boolean",
          title: "editor_reset_query_on_reset_label",
          default: false
        },
        "no-selected-filters-behaviour": {
          type: "string",
          title: "behaviour_no_selected_filters",
          default: "always_show",
          values: [
            { value: "disabled", text: i18n("editor_resetfilters_noSelectedFilterBehaviour_disabled") },
            { value: "hidden", text: i18n("editor_resetfilters_noSelectedFilterBehaviour_hidden") },
            { value: "always_show", text: i18n("editor_resetfilters_noSelectedFilterBehaviour_always_show") }
          ]
        }
      }
    }),

    createView: function (options) {
      options = _.extend({}, options, this.schema.parseAttributes(this.attributeModel.get()), this.schema.parseAttributes(this.attributeModel.getCamelCase()));
      return Template.prototype.createView.apply(this, [options].concat(Array.prototype.slice.call(arguments, 1)));
    }

  });

  ResetFilter.View = Base.extend({
    initialize: function () {
      var that = this;

      if (this.el.tagName !== "BUTTON") {
        var resetFilterContainer = document.createElement('div');
        resetFilterContainer.setAttribute('class', 'mb-filters-reset-filters');
        var resetFilterTitleContainer = document.createElement('div');
        var resetFilterTitle = document.createElement('h2');
        resetFilterTitle.innerHTML = i18n("filter_by");
        resetFilterTitle.setAttribute('class', 'component-title');
        resetFilterTitleContainer.appendChild(resetFilterTitle);

        this.resetFilterActionContainer = document.createElement('div');
        this.resetFilterActionContainer.classList.add('reset-filter-action');

        var resetFiltersWrapper = document.createElement('div');
        resetFiltersWrapper.setAttribute('class', 'mb-filters-reset-filters-action-container');
        var resetIcon = this.make("button", { "data-action-object": '{"resetSearchFilterQuery": {}}', "class": "btn btn-link reset-filter", "title": "" + i18n("reset_filters") + "" });
        $(resetFiltersWrapper).append('<i class="icon-remove"></i><span class="mb-acc">"' + i18n("reset_filters") + '"</span>');

        var resetLabel = document.createElement('label');
        resetLabel.innerHTML = i18n("reset_filters");
        $(resetFiltersWrapper).append(resetLabel);

        resetIcon.appendChild(resetFiltersWrapper);
        this.resetFilterActionContainer.appendChild(resetIcon);
        resetFilterContainer.appendChild(resetFilterTitleContainer);
        resetFilterContainer.appendChild(this.resetFilterActionContainer);
        this.appendChild(resetFilterContainer);
      }

      this.previousSourceContext = {};
      this.userQuery = {};
      this.defaultConstraintState = false;
      this.previousUserContext = {};
      this.defaultUserConstraintState = false;

      this.handleNoSelectedFilters();

      this.options.application.listenTo(
        this.options.application.models.search,
        "change",
        _.bind(this.onSearchModelChanged, that)
      );

      this.options.application.resetSearchFilterQuery = function () {
        var search = this.models.search;
        var userQueryPath = that.options.application.getUnparsedUserQueryPath().join('.').split('.query.unparsed')[0];
        that.handlerReset(search, userQueryPath);
      }
    },
    handlerReset: function (search, userQueryPath) {
      search.set(
        "source_context",
        this.handleResetConstraint(this.previousSourceContext),
        { silent: true }
      );
      Navigation.resetSelectedParams();
      if(this.resetFilterActionContainer){
        this.resetFilterActionContainer.classList.remove('show');
      }
      search.set("user",
        this.handleResetConstraint(this.previousUserContext),
        { silent: true }
      );

      if (this.options && this.options.clearQueryOnReset) {
        search.set(userQueryPath, { query: "" });
      } else {
        search.set(userQueryPath, { query: this.userQuery });
      }
      this.defaultConstraintState = false;
      this.defaultUserConstraintState = false;
    },

    handleResetConstraint: function (context) {
      var newContext = { constraints: {} };
      if (context && context.constraints) {
        newContext.constraints = deepClone(context.constraints);
      }
      return newContext;
    },

    onSearchModelChanged: function (options) {
      var queryPathWithoutUnparsed = this.options.application.getUnparsedUserQueryPath().join('.').split('.unparsed')[0];
      var queryObject = options.get(queryPathWithoutUnparsed);
      if (this.isUserQuery(options, 0) && queryObject) {
        this.userQuery = deepClone(queryObject);
      }else{
        this.userQuery = "";
      }
      if(options.input.get("user.constraints") || options.input.get("source_context.constraints.filter_datasources")) {
        this.defaultUserConstraintState = true;
      }
      if (this.isUserConstraint(options)) {
        if (!this.defaultUserConstraintState) {
          this.previousUserContext = deepClone(options.get("user"));
        }

        var currentUserContext = options.get("user");
        if (
          this.defaultUserConstraintState &&
          JSON.stringify(this.previousUserContext.constraints) !== JSON.stringify(currentUserContext.constraints)
        ) {
          this.resetFilterActionContainer && this.resetFilterActionContainer.classList.add('show');
          this.el.classList.remove("hidden");
          this.el.disabled = false;
          this.el.classList.remove("mb-reset-filters-disabled")
        } else {
          this.resetFilterActionContainer && this.resetFilterActionContainer.classList.remove('show');
          this.handleNoSelectedFilters()
        }
      }else{
        this.handleNoSelectedFilters()
      }

      if (this.isSourceContext(options)) {
        if (!this.defaultConstraintState) {
          this.previousSourceContext = deepClone(options.get("source_context"));
        }

        var context = {};
        if (this.previousSourceContext && this.previousSourceContext.constraints) {
          context = this.previousSourceContext.constraints;
        }

        var previousContextKeys = Object.keys(context);
        var currentContextKeys = Object.keys(options.get("source_context.constraints"));

        if (this.resetFilterActionContainer && this.defaultConstraintState && previousContextKeys.length !== currentContextKeys.length) {
          this.resetFilterActionContainer.classList.add('show');
        }
      }

      if (this.isUserQuery(options, 1)) {
        this.resetFilterActionContainer && this.resetFilterActionContainer.classList.add('show');
      }

      if (
        !this.isSourceContext(options) &&
        !this.isUserConstraint(options) &&
        !this.isUserQuery(options, 1) &&
        this.resetFilterActionContainer
      ) {
        this.resetFilterActionContainer.classList.remove('show');
      }

      this.defaultConstraintState = true;
      this.defaultUserConstraintState = true;
    },
    isUserConstraint: function (options) {
      return options.get("user.constraints") &&
        Object.keys(options.get("user.constraints")).length > 0;
    },
    isSourceContext: function (options) {
      return options.get("source_context.constraints") &&
        Object.keys(options.get("source_context.constraints")).length > 0
    },
    isUserQuery: function (options, conditionLength) {
      var queryPathWithoutUnparsed = this.options.application.getUnparsedUserQueryPath().join('.').split('.query.unparsed')[0];
      return options.get(queryPathWithoutUnparsed) &&
        Object.keys(options.get(queryPathWithoutUnparsed)).length > conditionLength
    },
    handleNoSelectedFilters: function() {      
      if(this.options && this.options.noSelectedFiltersBehaviour == "hidden"){
        this.el.classList.add("hidden");
      }
      if(this.options && this.options.noSelectedFiltersBehaviour == "disabled"){
        this.el.disabled = true;
        this.el.classList.add("mb-reset-filters-disabled")
      }
    }
  });

  return ResetFilter;
});
